import dayjs from 'dayjs'
import arraySupport from 'dayjs/plugin/arraySupport'
import { DAYS, DAYS_OBJ } from 'constant'

dayjs.extend(arraySupport)

const formatTime = (time = '') => (time.match(/[1-9]+:\d{2} \w+/) || [time])[0].toLowerCase()

const toMilitaryTime = (time = '') => {
  const match = time.match(/([1-9]+)(:\d{2}) (\w+)/)

  if (!match) {
    return ''
  }

  const [, hour, minute, timeOfDay] = match
  const pmHour = Number(hour) + 12
  return timeOfDay.toLowerCase() === 'am' ? `${hour}${minute}` : `${pmHour}${minute}`
}

const schemaFormatDay = (day = '') => day && day.match(/^\w{2}/)[0]

const combineDays = (firstDay = '', lastDay = '') => lastDay ? `${firstDay}-${lastDay}` : firstDay

const formatDay = (abbrDay = '') => DAYS.find(day => day.match(new RegExp(abbrDay, 'i')))

export const workingHoursDistinct = (workingHours = []) => {
  const workingHoursShortCut = []
  let previousWorkingHoursMask = false
  let currentIndex = -1

  workingHours.forEach(({ day, openingHour, closingHour }, index) => {
    const workingHoursMask = `${openingHour} - ${closingHour}`
    const formattedDay = formatDay(day)

    if (workingHoursMask !== previousWorkingHoursMask) {
      workingHoursShortCut.push({
        days: [formattedDay],
        order: index + 1,
        openingHour: formatTime(openingHour),
        closingHour: formatTime(closingHour)
      })
      currentIndex += 1
    } else {
      workingHoursShortCut[currentIndex].days.push(formattedDay)
    }
    previousWorkingHoursMask = workingHoursMask
  })

  return workingHoursShortCut.map(item => {
    const { days, order, openingHour, closingHour } = item
    const firstDay = days.shift()
    const lastDay = days.pop()
    const day = combineDays(firstDay, lastDay)
    const schemaDay = combineDays(schemaFormatDay(firstDay), schemaFormatDay(lastDay))
    const schemaHours = `${schemaDay} ${toMilitaryTime(openingHour)}-${toMilitaryTime(closingHour)}`

    return {
      day,
      order,
      openingHour,
      closingHour,
      schemaHours
    }
  })
    .sort((a, b) => a.order - b.order)
}

export const processSpecialHours = (specialHours = []) => {
  const start = dayjs().startOf('day')
  const end = dayjs(start).add(2, 'weeks')

  return specialHours.map(d => {
    const [month, day] = d.date.split('/')
    const date = dayjs([start.year(), (Number(month) - 1), Number(day)])
    const epochNum = date.valueOf()
    const dateNextYear = dayjs(date).add(1, 'year')
    const workingHours = (d.workingHours || '').split('-').map(wh => wh.trim()).join(' - ')
    if (
      (date >= start && date <= end) || (date < end && dateNextYear <= end)
    ) {
      const dateRange = d.endDate && d.endDate !== d.date ? `${d.date} - ${d.endDate}` : d.date
      return { ...d, epochNum, workingHours, dateRange }
    }
    return false
  }).filter(d => d)
}

export const generateOpeningHoursSpecification = (workingHours = []) =>
  workingHours.map(({ openingHour, closingHour, day }) => ({
    '@context': 'http://schema.org',
    '@type': 'openingHoursSpecification',
    closes: `${toMilitaryTime(closingHour)}`,
    dayOfWeek: `http://schema.org/${DAYS_OBJ[day]}`,
    opens: `${toMilitaryTime(openingHour)}`
  }))
